function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 10C5.9 10 5.5 8.6665 5.5 8H1.5V9C1.5 9.26522 1.60536 9.51957 1.79289 9.70711C1.98043 9.89464 2.23478 10 2.5 10H7.5ZM7.5 10C7.89782 10 8.27936 9.84196 8.56066 9.56066C8.84196 9.27936 9 8.89782 9 8.5V5M9 5H9.5C9.76522 5 10.0196 4.89464 10.2071 4.70711C10.3946 4.51957 10.5 4.26522 10.5 4V3C10.5 2.73478 10.3946 2.48043 10.2071 2.29289C10.0196 2.10536 9.76522 2 9.5 2H9M9 5V2M9 2H3.5C3.23478 2 2.98043 2.10536 2.79289 2.29289C2.60536 2.48043 2.5 2.73478 2.5 3V8M7 4H4.5M5.5 6H4.5",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgGameRules = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGameRules, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/game_rules.79b8a31b.svg";
export { ForwardRef as ReactComponent };